
import { defineComponent } from 'vue';
import { useList } from '@/hooks/use-list';
import { getUserInfoPage } from '@/api/manage-app/user-info';
import {
  IUserInfoParams,
  IUserInfoItem,
} from '@/api/manage-app/user-info/index.d';
import CreatedUser from './components/created-user.vue';
import DisabledDevUser from './components/disabled-dev-user.vue';
import DevUserLogs from './components/dev-user-logs.vue';
import { _CreatedUser } from './composables/index';
import {
  APP_IS_ENABLED_LIST,
  APP_USER_SOURCE_LIST,
  WORK_STATUS_LIST,
  WORK_STATUS_ENUM,
} from '@/constant';
import usePermissionConfig from './use-permission-config';

export default defineComponent({
  name: 'DevUserManage',
  components: {
    CreatedUser,
    DisabledDevUser,
    DevUserLogs,
  },
  setup() {
    const {
      params,
      tableData,
      tableTotal,
      tableLoading,
      handleSearch,
      handleReset,
      handleSizeChange,
      handleCurrentChange,
    } = useList<IUserInfoItem, IUserInfoParams>({
      request: {
        api: getUserInfoPage,
        params: {
          userName: '',
          accountName: '',
          pageNum: 1,
          pageSize: 10,
          dataChannel: '',
          workState: '',
          userUDID: '',
        },
      },
    });
    handleSearch();
    const {
      handleCreated,
      handleRefreshWorkStatus,
      createdUserVisible,
      disabledVisible,
      handleDisabled,
      handleDel,
      handleShowLogs,
      logVisible,
      handelUserEdit,
      accountUserItem,
      handleEnable,
      accountList,
      gridData,
    } = _CreatedUser();

    const permissionConfig = usePermissionConfig();

    return {
      params,
      tableData,
      tableTotal,
      tableLoading,
      handleSearch,
      handleReset,
      handleSizeChange,
      handleCurrentChange,
      handleCreated,
      createdUserVisible,
      disabledVisible,
      handleDisabled,
      handleDel,
      handleShowLogs,
      logVisible,
      APP_IS_ENABLED_LIST,
      handleEnable,
      handelUserEdit,
      accountUserItem,
      accountList,
      gridData,
      permissionConfig,
      APP_USER_SOURCE_LIST,
      WORK_STATUS_LIST,
      WORK_STATUS_ENUM,
      handleRefreshWorkStatus: handleRefreshWorkStatus(handleSearch),
    };
  },
});
